import { useState } from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { adminApi, setToken, formatApiErrorDetail } from "../../lib/adminApi";

const inputCls =
  "w-full bg-transparent border-b border-white/15 focus:border-champagne outline-none py-3 text-sm font-light text-ivory placeholder:text-stone-600 transition-colors duration-300";

export default function AdminLogin({ onSuccess }) {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    setError("");
    try {
      const { data } = await adminApi.post("/auth/login", { email, password });
      setToken(data.token);
      onSuccess({ email: data.email, name: data.name });
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail) || err.message);
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center px-6 bg-[#0D0D10]">
      <motion.div
        initial={{ opacity: 0, y: 30 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.9, ease: [0.22, 1, 0.36, 1] }}
        className="w-full max-w-md border border-white/10 bg-elevated p-10"
      >
        <p className="text-[11px] font-mono tracking-[0.25em] uppercase text-stone-500">Studio Access</p>
        <h1 className="mt-3 font-serif text-3xl text-ivory">
          Private <span className="italic text-champagne">Atelier</span>
        </h1>
        <form onSubmit={submit} className="mt-10 space-y-7" data-testid="admin-login-form">
          <div>
            <label htmlFor="admin-email" className="text-[10px] font-mono tracking-[0.25em] uppercase text-stone-500">Email</label>
            <input id="admin-email" data-testid="admin-email-input" type="email" required autoComplete="username" value={email} onChange={(e) => setEmail(e.target.value)} className={inputCls} placeholder="studio@elegancenoire.com" />
          </div>
          <div>
            <label htmlFor="admin-password" className="text-[10px] font-mono tracking-[0.25em] uppercase text-stone-500">Password</label>
            <input id="admin-password" data-testid="admin-password-input" type="password" required autoComplete="current-password" value={password} onChange={(e) => setPassword(e.target.value)} className={inputCls} placeholder="••••••••" />
          </div>
          {error && (
            <p data-testid="admin-login-error" className="text-xs font-light text-terracotta">{error}</p>
          )}
          <button
            type="submit"
            data-testid="admin-login-submit"
            disabled={busy}
            className="w-full bg-champagne text-obsidian px-10 py-4 text-[11px] font-mono tracking-[0.2em] uppercase hover:bg-ivory transition-colors duration-300 disabled:opacity-50"
          >
            {busy ? "Unlocking…" : "Enter Atelier"}
          </button>
        </form>
        <Link to="/" data-testid="admin-back-home" className="mt-8 inline-block text-[10px] font-mono tracking-[0.2em] uppercase text-stone-500 hover:text-champagne transition-colors">
          ← Return to site
        </Link>
      </motion.div>
    </div>
  );
}
